import React, { useState } from "react";
import BrochureModal from "./BrochureModal";
import "../../page_content.css";

const Brochure = () => {
  const [showBrochure, setShowBrochure] = useState(false);

  return (
    <div>
      <h1 className="title">Admission Brochure</h1>
      <hr />
      <div className="page-content-container" id="page-links">
        <p>To download the brochure:</p>

        <button onClick={() => setShowBrochure(true)}>
          View Brochure
        </button>

        {showBrochure && (
          <BrochureModal onClose={() => setShowBrochure(false)} />
        )}
      </div>
    </div>
  );
};

export default Brochure;